import React from 'react';
import TenantBrandLockup from '../brand/TenantBrandLockup';
import './admin.css';

export default function AdminHub({ profile, onNavigate, onMemberDashboard, headerExtra = null, contentPrefix = null }) {
  const navigate = path => {
    if (typeof onNavigate === 'function') onNavigate(path);
    else window.location.assign(path);
  };
  const memberDashboard = () => {
    if (typeof onMemberDashboard === 'function') onMemberDashboard();
    else navigate('/');
  };

  if (!profile?.is_admin) {
    return (
      <div className="admin-root">
        <main className="admin-page">
          <section className="admin-card admin-denied">
            <h1>Admin access required</h1>
            <p>Your member account does not have program-admin access.</p>
            <button type="button" onClick={memberDashboard}>Back to Dashboard</button>
          </section>
        </main>
      </div>
    );
  }

  return (
    <div className="admin-root">
      <header className="admin-topbar">
        <div>
          <TenantBrandLockup profile={profile} compact />
          <p style={{ marginTop: 8 }}>Line Medic Admin · program operations, member access, communications, deployments, and physical inventory</p>
        </div>
        <div className="admin-topbar-actions">
          {headerExtra}
          <button type="button" onClick={memberDashboard}>Member Dashboard</button>
        </div>
      </header>
      <main className="admin-page">
        {contentPrefix}
        <div className="admin-hub-grid">
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/attention')}>
            <span className="admin-hub-kicker">ATTENTION</span>
            <strong>Needs Attention</strong>
            <p>One place for gear exceptions, open handoffs, active deployments, and inventory approaching expiration.</p>
            <span>Review attention items →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/program-feed')}>
            <span className="admin-hub-kicker">COMMUNICATIONS</span>
            <strong>Program Feed</strong>
            <p>Publish Line Medic updates, choose push or in-app delivery, allow comments, and require acknowledgments when needed.</p>
            <span>Manage Program Feed →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/prescribed-burns')}>
            <span className="admin-hub-kicker">OPERATIONS</span>
            <strong>Prescribed Burns</strong>
            <p>Create burn opportunities, collect volunteers, select the final roster, notify members, and link assignments into My Gear.</p>
            <span>Manage prescribed burns →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/notifications')}>
            <span className="admin-hub-kicker">PUSH DELIVERY</span>
            <strong>Notification Audit</strong>
            <p>Review queued, accepted, failed, invalid-token, and no-token push events without confusing provider acceptance with member receipt.</p>
            <span>Review notifications →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/door-access')}>
            <span className="admin-hub-kicker">ACCESS AUDIT</span>
            <strong>Door Access</strong>
            <p>Review Gear Room access, signed hardware activity, filters, date ranges, and CSV exports in one place.</p>
            <span>Review Door Access →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/deployments')}>
            <span className="admin-hub-kicker">OPERATIONS</span>
            <strong>Deployment Dashboard</strong>
            <p>Who is deployed, where they are, days out, assigned gear, gear availability, OOS status, and season numbers.</p>
            <span>Open dashboard →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/deployments?tab=history')}>
            <span className="admin-hub-kicker">CHAIN OF CUSTODY</span>
            <strong>Asset History</strong>
            <p>Search a physical asset to see current status, last assignment, incident, checkout/return details, condition, and prior deployment history.</p>
            <span>Look up an asset →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/inventory-admin')}>
            <span className="admin-hub-kicker">LOGISTICS</span>
            <strong>Inventory</strong>
            <p>Physical bag inventory, barcode scanning, restock requests, preseason planning, and seasonal closeout.</p>
            <span>Open inventory →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/members')}>
            <span className="admin-hub-kicker">ACCESS</span>
            <strong>Member Management</strong>
            <p>Approve members, grant or remove program-admin access, manage notification roles, and disable accounts.</p>
            <span>Manage members →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/tags')}>
            <span className="admin-hub-kicker">ASSET ID</span>
            <strong>QR / NFC Tag Setup</strong>
            <p>Registered pack identities, permanent public recovery links, NFC programming, and QR/NFC verification.</p>
            <span>Set up tags →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/recall')}>
            <span className="admin-hub-kicker">SAFETY</span>
            <strong>Lot / Recall Lookup</strong>
            <p>Search a lot, product, GTIN/barcode, expiration, or container and locate every matching active physical unit immediately.</p>
            <span>Open recall lookup →</span>
          </button>
          <button type="button" className="admin-hub-card" onClick={() => navigate('/admin/health')}>
            <span className="admin-hub-kicker">SYSTEM</span>
            <strong>System Health</strong>
            <p>Check tracking, inventory, Supabase/member access, atomic concurrency protection, and restock email configuration.</p>
            <span>Check system →</span>
          </button>
        </div>
      </main>
    </div>
  );
}
